import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckIcon, XIcon } from 'lucide-react';
const rows = [{
  feature: '6 Tomos PROTORRENDA',
  base: true,
  combo: true
}, {
  feature: '2 Bonos',
  base: true,
  combo: true
}, {
  feature: 'Pelotón 10X',
  base: false,
  combo: true
}, {
  feature: 'Tácticas de Viento',
  base: false,
  combo: true
}, {
  feature: 'Posicionamiento en Pelotón',
  base: false,
  combo: true
}, {
  feature: 'Mentalidad de Competidor',
  base: false,
  combo: true
}];
function Check() {
  return <div className="w-8 h-8 rounded-md bg-green-500/20 flex items-center justify-center" role="img" aria-label="Incluido" data-id="element-76">
      <CheckIcon className="w-5 h-5 text-green-400" strokeWidth={3} aria-hidden="true" data-id="element-77" />
    </div>;
}
function Cross() {
  return <div className="w-8 h-8 rounded-md bg-red-500/15 flex items-center justify-center" role="img" aria-label="No incluido" data-id="element-78">
      <XIcon className="w-5 h-5 text-red-400" strokeWidth={3} aria-hidden="true" data-id="element-79" />
    </div>;
}
export function PackComparisonTable() {
  return <div className="px-4 bg-slate-950" data-id="element-80">
      <div className="max-w-2xl mx-auto" data-id="element-81">
        <FadeIn data-id="element-82">
          <div className="rounded-xl border border-slate-700/80 overflow-hidden" data-id="element-83">
            <table className="w-full" role="table" aria-label="Comparación de packs: Pack Base vs Base + Pelotón 10X" data-id="element-84">
              <thead data-id="element-85">
                <tr data-id="element-86">
                  <th scope="col" className="bg-slate-950 p-4 md:p-5 border-b border-slate-700/80 text-left" data-id="element-87">
                    <span className="sr-only" data-id="element-88">Característica</span>
                  </th>
                  <th scope="col" className="bg-slate-950 p-4 md:p-5 border-b border-l border-slate-700/80 text-center" data-id="element-89">
                    <span className="text-white font-black text-xs md:text-sm tracking-wider uppercase" data-id="element-90">
                      PACK
                      <br data-id="element-91" />
                      BASE
                    </span>
                  </th>
                  <th scope="col" className="bg-slate-900/70 p-4 md:p-5 border-b border-l border-slate-700/80 text-center" data-id="element-92">
                    <span className="text-green-400 font-black text-xs md:text-sm tracking-wider uppercase leading-tight" data-id="element-93">
                      BASE +<br data-id="element-94" />
                      PELOTÓN 10X
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-95">
                {rows.map((row, i) => <tr key={i} data-id="element-96">
                    <th scope="row" className={`${i % 2 === 0 ? 'bg-slate-900/40' : 'bg-slate-900/20'} p-4 md:p-5 border-b border-slate-700/50 text-left`} data-id="element-97">
                      <span className="text-slate-200 text-sm md:text-base font-medium" data-id="element-98">
                        {row.feature}
                      </span>
                    </th>
                    <td className={`${i % 2 === 0 ? 'bg-slate-900/40' : 'bg-slate-900/20'} p-4 md:p-5 border-b border-l border-slate-700/50 text-center`} data-id="element-99">
                      {row.base ? <Check data-id="element-100" /> : <Cross data-id="element-101" />}
                    </td>
                    <td className={`${i % 2 === 0 ? 'bg-slate-900/60' : 'bg-slate-900/40'} p-4 md:p-5 border-b border-l border-slate-700/50 text-center`} data-id="element-102">
                      {row.combo ? <Check data-id="element-103" /> : <Cross data-id="element-104" />}
                    </td>
                  </tr>)}
              </tbody>
              <tfoot data-id="element-105">
                <tr className="border-t border-slate-600" data-id="element-106">
                  <th scope="row" className="bg-slate-950 p-4 md:p-6 text-left" data-id="element-107">
                    <span className="text-white text-sm md:text-base font-black tracking-wide" data-id="element-108">
                      PRECIO
                    </span>
                  </th>
                  <td className="bg-slate-950 p-4 md:p-6 border-l border-slate-700/80 text-center" data-id="element-109">
                    <span className="text-white font-black text-lg md:text-2xl" data-id="element-110">
                      $19.990
                    </span>
                  </td>
                  <td className="bg-slate-900/70 p-4 md:p-6 border-l border-slate-700/80 text-center" data-id="element-111">
                    <span className="text-green-400 font-black text-lg md:text-2xl" data-id="element-112">
                      $29.990
                    </span>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </FadeIn>

        {/* Callout Box */}
        <FadeIn delay={0.2} data-id="element-113">
          <div className="mt-10 rounded-2xl border border-amber-500/30 bg-slate-900 p-8 md:p-10 text-center shadow-lg" role="note" aria-label="Oferta especial" data-id="element-114">
            <p className="text-2xl md:text-3xl font-bold text-amber-500 mb-4" data-id="element-115">
              <span aria-hidden="true" data-id="element-116">💡</span> Solo $10.000 ARS más.
            </p>
            <p className="text-white text-lg md:text-xl mb-3" data-id="element-117">
              El Pelotón 10X por separado vale $19.990 ARS.
            </p>
            <p className="text-green-500 italic text-base md:text-lg" data-id="element-118">
              Agregándolo ahora lo llevás a la mitad del precio.
            </p>
          </div>
        </FadeIn>
      </div>
    </div>;
}